import React from 'react';
import GolfBookingConfirmContainer from '../organisms/golfBookingConfirmContainer';
import GolfCancelPopup from '../organisms/golfCancelPopup';
import { GolfHeaderContainer } from '../organisms/golfHeaderContainer';
import GolfReservationPopupContainer from '../organisms/golfReservationPopupContainer';

class GolfBookingConfirmTemplate extends React.Component {

    render() {
        return (
            <>
                <GolfHeaderContainer
                    Label categoryLabel1={"予約内容確認"}
                    categoryLabel2={"CONFIRM"}
                    path={"/reserve/golf/search"}
                    bookedConfirmLabel={"予約確認"}
                    onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
                />
                <GolfBookingConfirmContainer
                    state={this.props.state}
                    onClickOpenCalendarWindow={this.props.onClickOpenCalendarWindow}
                    onClickOpenCancelPopupWindow={this.props.onClickOpenCancelPopupWindow}
                />
                <GolfReservationPopupContainer
                    state={this.props.state}
                    onClickClosePopupWindow={this.props.onClickClosePopupWindow}
                />
                <GolfCancelPopup
                    state={this.props.state}
                    onClickCloseCancelPopupWindow={this.props.onClickCloseCancelPopupWindow}
                />
            </>
        )
    }
}
export default GolfBookingConfirmTemplate;